import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.5 16.5h5.25a.75.75 0 0 1 0 1.5H1.5A1.5 1.5 0 0 1 0 16.5v-15A1.5 1.5 0 0 1 1.5 0h5.25a.75.75 0 0 1 0 1.5H1.5zm12.347-3.028 3.937-3.938a.76.76 0 0 0 0-1.068l-3.937-3.938a.752.752 0 0 0-1.06 1.069l2.654 2.653H6.75a.75.75 0 0 0 0 1.5h8.69l-2.652 2.653a.75.75 0 0 0 .524 1.284c.2 0 .39-.077.535-.215",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }